import React, { ChangeEvent } from 'react';

interface FormFieldProps {
  type: string;
  name: string;
  placeholder?: string;
  svgPath: string;
  value: string | number;
  className?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const FormField: React.FC<FormFieldProps> = ({ type, name, placeholder, svgPath, value, onChange, className }) => {
  return (
    <label
      className={`input input-bordered input-primary flex items-center gap-2 input-sm lg:input-md w-full max-w-xs ${
        className || ''
      }`}
    >
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentColor' className='h-4 w-4 opacity-70'>
        <path d={svgPath} />
      </svg>
      <input
        style={{
          WebkitBoxShadow: '0 0 0 1000px transparent inset',
          WebkitTextFillColor: 'inherit',
        }}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className='grow  placeholder-custom text-primary'
        placeholder={placeholder}
      />
    </label>
  );
};

export default FormField;
